import {createFileRoute} from '@tanstack/react-router';

import {VisitorGroupPage} from '@/modules/admin-visitors/pages/VisitorGroupPage';

const RouteComponent = () => {
  const {groupId} = Route.useParams();
  return <VisitorGroupPage groupId={groupId} />;
};

export const Route = createFileRoute('/_authenticated/admin/visitors/$groupId')({
  component: RouteComponent,
});
